// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobeIllustratorIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#300"
      d="M5.54 2h12.92A3.6 3.6 0 0 1 22 5.63v12.74c0 2-1.58 3.63-3.54 3.63H5.54A3.6 3.6 0 0 1 2 18.37V5.63C2 3.63 3.58 2 5.54 2"
    />
    <path
      fill="#FF9A00"
      d="M11.67 13.97h-3.1l-.64 2a.15.15 0 0 1-.16.12H6.21q-.14 0-.1-.15L8.8 8.02l.08-.28q.05-.27.05-.56 0-.07.07-.1h2.16q.1 0 .1.07l3.05 8.8q.04.15-.09.14h-1.74q-.1 0-.13-.09zm-2.62-1.74h2.12q-.08-.28-.2-.61l-.22-.74-.24-.79q-.13-.38-.23-.76l-.18-.66h-.02q-.1.54-.28 1.1l-.38 1.26q-.19.66-.37 1.2m7.12-3.65q-.44 0-.75-.3c-.19-.21-.29-.5-.28-.78a1 1 0 0 1 1.04-1.06q.5 0 .76.3.27.31.28.76 0 .45-.3.78c-.19.2-.47.32-.75.3M15.23 16V9.42q0-.13.11-.12H17q.11 0 .11.12V16q0 .15-.1.14h-1.64q-.13 0-.13-.14"
    />
  </svg>,
  "AdobeIllustrator",
);
export default AdobeIllustratorIcon;
